var map = {
	"./events/2011-B.png": "kZ7X",
	"./events/2011.png": "kpac",
	"./events/2012-B.png": "4Euw",
	"./events/2012.png": "aoAN",
	"./events/2013-B.png": "luXU",
	"./events/2013.png": "hTy0",
	"./events/2014-B.png": "qIz/",
	"./events/2014.png": "qnWF",
	"./events/2015-B.png": "g6JI",
	"./events/2015.png": "1yri",
	"./events/2016-B.png": "KMkj",
	"./events/2016.png": "256j",
	"./events/2017-B.png": "59ZA",
	"./events/2017.png": "iCb2",
	"./events/2018-B.png": "FZMT",
	"./events/2018.png": "VsI3",
	"./events/2019-B.png": "630G",
	"./events/2019.png": "dXEJ",
	"./events/2020-B.png": "3Mxi",
	"./events/2020.png": "8lXz",
	"./events/2021-B.png": "NC/G",
	"./events/2021.png": "XiO8",
	"./newEvents/2011.png": "/cZn",
	"./newEvents/2011@2x.png": "YCEQ",
	"./newEvents/2012.png": "hHEu",
	"./newEvents/2012@2x.png": "VBA+",
	"./newEvents/2013.png": "kjPP",
	"./newEvents/2013@2x.png": "sLzE",
	"./newEvents/2014.png": "1dTV",
	"./newEvents/2014@2x.png": "L5uw",
	"./newEvents/2015.png": "t1Sj",
	"./newEvents/2015@2x.png": "t62i",
	"./newEvents/2016.png": "g4G/",
	"./newEvents/2016@2x.png": "eLd5",
	"./newEvents/2017.png": "WkRu",
	"./newEvents/2017@2x.png": "18Gm",
	"./newEvents/2018.png": "q8JD",
	"./newEvents/2018@2x.png": "nu/n",
	"./newEvents/2019.png": "KPeQ",
	"./newEvents/2019@2x.png": "/cxI",
	"./newEvents/2020.png": "Wyrx",
	"./newEvents/2020@2x.png": "u134",
	"./newEvents/2021.png": "3YBU",
	"./newEvents/2021@2x.png": "g+Am",
	"./news1.jpg": "YMgR",
	"./news2.jpg": "2yfh",
	"./news3.jpg": "R9H5",
	"./news4.jpg": "O0ro",
	"./news5.jpg": "BUcc",
	"./news6.jpg": "9J5u",
	"./section-1-text.png": "ILzc",
	"./section-1.jpg": "Ia15",
	"./section-2.jpg": "4PZo",
	"./section-3.gif": "j3DK",
	"./section-3.jpg": "YC7a",
	"./section-4.jpg": "CqQ6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bjO3";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic ^\.\/.*$
// module id = bjO3
// module chunks = 1